import { Category } from '../types/api';

export const getCanonicalCategoryId = (category: Category): string =>
  category.canonicalId || category.id;

export const getCategoryUrl = (category: Category): string =>
  `/catalog/${getCanonicalCategoryId(category)}`;

export const removeCanonicalWrapperCategories = (
  path: Category[] | null,
): Category[] | null => {
  if (!path) return null;
  return path.filter((category, index) => {
    const next = path[index + 1];
    return !next || getCanonicalCategoryId(category) !== next.id;
  });
};
